module.exports = __webpack_public_path__ + "26f89510c41a4b5c359e0c6e73008f4b.svg";